<template>
    <div class="inPage">
        <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
        <section class="inContactMapBox">
            <div class="wrapper">
                <div class="inContactMap">
                    <BaiduMap />
                    <!-- 悬浮 -->
                    <div class="onTheMap1">
                        <div class="onTheMap1_name">{{isZhong?'公司总部':"Company's Headquarters"}}</div>
                        <div class="onTheMap1_list">
                            {{isZhong?'地址':'Address'}}:{{isZhong?lableInfo.cnAddress:companyInfo.address}} <br>
                            {{isZhong?'电话':'Phone'}}:{{companyInfo.phone}} <br>
                            {{isZhong?'传真':'Fax'}}:{{companyInfo.fax}} <br>
                            {{isZhong?'邮箱':'Email'}}:{{companyInfo.email}}
                        </div>

                    </div>
                    <!-- 悬浮end -->
                </div>
                
            </div>
        </section>
       
    </div>
</template>

<script>
import BannerIn from '../../components/BannerIn/BannerIn'
import NavIn from '../../components/NavIn/NavIn'
import BaiduMap from '../../components/BaiduMap/BaiduMap'
import BaiduMap2 from '../../components/BaiduMap/BaiduMap2'

import { getSort,getCompany,getLable } from '../../api'

export default {
    components:{
        BannerIn,
        NavIn,
        BaiduMap,
        BaiduMap2
    },
    data(){
        return{
            bannerUrl:'./static/images/banner5.jpg',
            positionInfo:{
                second:'CONTACT US',
                third:''
            },
            companyInfo:{},
            lableInfo:{},
            isZhong:false,
            isShowMap:true
        }
    },
    async created(){

       const language = this.$cookies.get('language');
       let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong; 
       let positionInfo = {};

        if(isZhong){
            positionInfo={
                second:'联系我们',
                third:''
            }
        }else{
            positionInfo={
                second:'CONTACT US',
                third:''
            }
        }
        this.positionInfo = positionInfo;



       //更新bannerIn
       const res = await getSort(11);
       this.bannerUrl = res.data.pic;

       const res2 = await getCompany();
       this.companyInfo = res2.data;

       const res3 = await getLable();
       this.lableInfo = res3.data;

    }
};
</script>
<style lang="scss" scoped>
@import '../../common/css/mixin.scss';
.inContactMapBox {
  background:#fafdfd;  
  padding: 86px 0;
  .wrapper {
    .inContactMap {
      
    }
  }
}
.inContactAddressBox {
  padding: 86px 0;  
  background:url('../../common/images/beijing_def.jpg')  no-repeat; 
  background-size: cover;
  .wrapper {
    .inContact_title {
      display: flex;
      .ico {
        width: 74px;  
        img {
            width: 100%;
            height: 36px;
        }
      }
      .text {
          flex: 1;
          height: 36px;
          line-height: 36px;
          margin-left: 16px;
          color: $themeColor;
          font-size: 26px;
          font-weight: bold;
      }
    }
    .inContact_list {
      margin-top: 46px;
      @include flexFather;
      .inContactItem {
        padding: 38px 22px 44px 26px;  
        background: #fff;

        width: 32%;
        @include boxSizing;
        position: relative;
        z-index: 2;
        .title {
            font-size: 18px;
            font-weight: bold;
            line-height: 24px;
            color: $themeColor;
        }
        .cen {
            line-height: 26px;
            margin-top: 12px;
        }
        &::before{
            content: '';
            position:absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(13, 105, 175, 0.8);
            z-index: -1;
            display: none;
        }
        &:hover{
            // background: url('../../common/images/beijing_01.jpg')  no-repeat;
            background: url('../../common/images/beijing_01.jpg')  no-repeat;
            background-size: cover;
            .title{
                color: #fff;
            }
            .cen{
                color: #fff;
            }
            &::before{
                display: block;
            }
        }
      }
    }
  }
}
.inContactMap {
      width: 100%;
      position: relative;
      .onTheMap1 {
        width: 500px;
        position: absolute;
        z-index: 2;
        top:56px;
        right: 46px;
        padding: 56px 38px 44px 38px;
        background: rgba(13, 105, 175, 0.8);
        @include compatible(border-radius,15px );
        @include boxSizing;
        .onTheMap1_name {
          line-height: 36px;
          color: #fff;
          font-size: 24px;
          margin-bottom: 12px;
        }
        .onTheMap1_list {
            line-height: 34px;
            display: flex;
            color: #fff;
            width: 100%;
        }
      }
}

@media only screen and (max-width: 991px){
    .inContactMap {
        
        .onTheMap1 {
            width: 100%;
            position: initial;
            padding: 22px 12px 22px 26px;
            margin-top: 1rem;
            .onTheMap1_name{
                font-size: 16px;
            }
        }
            .onTheMap1_list {
                font-size: 14px;
            }
        }
}

</style>



// WEBPACK FOOTER //
// src/pages/Contact/Contact.vue